// src/App.js
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Lazy load pages for code splitting
const Layout = lazy(() => import("./components/Layout"));
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Products = lazy(() => import("./pages/Products"));
const Distributors = lazy(() => import("./pages/Distributors"));
const Contact = lazy(() => import("./pages/Contact"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Language redirect component
const LanguageRedirect = () => {
  const { i18n } = useTranslation();
  const userLang = i18n.language.split('-')[0];
  const supportedLangs = ['en', 'es', 'fr', 'de', 'zh', 'tr', 'ru', 'it', 'uk'];
  const defaultLang = supportedLangs.includes(userLang) ? userLang : 'en';
  
  return <Navigate to={`/${defaultLang}`} replace />;
};

function App() {
  return (
    <Routes>
      {/* Root redirects to language */}
      <Route path="/" element={<LanguageRedirect />} />
      
      {/* Language-specific routes */}
      <Route path="/:lang" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="products" element={<Products />} />
        <Route path="distributors" element={<Distributors />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
      </Route>
      
      {/* 404 for all other routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;